<div class="row ss-top-menu">
  <div class="col-sm-3">
    <span class="ss-text-dark d-inline-block mt-3" style="vertical-align: -webkit-baseline-middle;">Dashboard <i
        class="rightArrow fa fa-angle-right"></i></span>
    <span class="ss-text-dark d-inline-block mt-3" style="vertical-align: -webkit-baseline-middle;">Adjustments</span>
  </div>
  <div class="col-sm-9 align-items-center ">
    <button class="downloadBtn btn pull-right mt-2" data-toggle="modal" data-target="#adustment">
      Create New Adjustment
    </button>
</div>
</div>
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="mt-4 container-set">
  <div class="row">
    <div class="col-md-12" *ngIf="AdjustmentsList && AdjustmentsList.length > 0" >
      <div class="tableDiv table-responsive ">
        <div class="tableDiv">

          <table class="table">
            <thead>
              <tr>
                <th class="text-center firstTh">#</th>
                <th class="sname text-center">ID</th>
                <th class="minaddress text-center">Adjustment Date</th>
                <th class="text-center">Adjustment Value</th>
              
                <th class="pl-store minaddress2 ">Created By</th>
                <th></th>
               
              </tr>
            </thead>
            <tbody>
             <tr  *ngFor="let data of AdjustmentsList  | paginate
          : {
            itemsPerPage: per_page,
            currentPage: currentPage,
            totalItems: total_page
          }  ;let i = index " >
            <td class="text-center">
              {{currentPage*15+i+1-15}}
            </td>
             <td class="text-center">
              {{data.id}}
            </td>
             <td class="text-center">
              {{data.adjustment_date | date :'dd-MM-yyyy'}}
            </td>
             <td class="text-center">
              {{data.adjustment_value | indaincur}}
            </td>
            <td >
              <span class="capitalize text-info" >Name : {{data.who_did_it.name}}</span><br>
               <span class="text-info">Email : {{data.who_did_it.email}}</span>
            
            </td>
            <td>
              <button class="downloadBtn btn ml-3" (click)="deleteDetails(data.id)">
                    <i class="fa fa-trash"></i> 
                    
                  </button>
            </td>

             </tr>
            </tbody>
          </table>
          <div class="text-center">
  <pagination-controls autoHide="true"(pageChange)="current_page = getAdjustments($event)" ></pagination-controls>
 </div>
        </div>
       
      </div>
    </div>
    <div class="col-md-12 not-found " *ngIf=" AdjustmentsList && AdjustmentsList.length==0 " >
      <div class="boq-img text-center">
        <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
      </div>
      <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">No Adjustments to display...</p>
    </div>
  </div>
</div>
<div class="modal fade" id="adustment" role="dialog">
  <div class="modal-dialog modal-lg" role="document" style="max-width: 32%">
  <div class="modal-content" >
    <div class="modal-header">
      <h5 class="modal-title modalTitle addClass" (click)="closeModal()" id="exampleModalLabel">Create Adjustment</h5>
      <img class="close" (click)="closeModal()" data-dismiss="modal" src="./assets/img/finance/cancel.png">
    </div>
    <div class="modal-body leadView" >
      <form class="viewProfileForm" [formGroup]="AdustmentForm">
        <div class="row addClass">
          <div class="col-sm-12 col-md-12" (mouseleave)="workChange()" (mouseenter)="workChange()">
            <div class="form-group">
              <label>Adjustment Month<span class="text-danger">*</span></label>

              <input type="text" placeholder="Select Adjustment Month" class=" w-100 rk-form-fontsize d-block rounded px-2 p-1" formControlName="adjustment_date"  id="startDateNewpro" (focus)="DateForWorkStart()" readonly>
            
            
            </div>
          </div>
          <div class="col-sm-12 col-md-12" (mouseleave)="workChange()" (mouseenter)="workChange()">
            <div class="form-group">
              <label>Adjustment Value<span class="text-danger">*</span></label>
              <input type="number" class="form-control"  placeholder=" Enter Adjustment Value" formControlName="adjustment_value" >
            </div>
          </div>
          
       
          <div class="col-sm-12 col-md-12">
            <button type="button" class="btn addCursor  btn-pink pull-right" (click)="submitDetails()"  [disabled]="!AdustmentForm.valid">Submit</button>
           
            <a class="cursor-pointer pull-right mt-1 mr-2" (click)="closeModal()">Cancel</a>
          </div> 
        </div>
      </form>  
    </div>
  </div>
</div></div>



// WEBPACK FOOTER //
// ./src/app/platform/finance/adustments/adustments.component.html